(function () {
  function paintJoyCraftMobileCards() {
    var isMobile = window.matchMedia && window.matchMedia('(max-width: 767px)').matches;

    document.querySelectorAll('.m-product-card--style-joycraft').forEach(function (card) {
      var nodes = card.querySelectorAll('.m-product-card__background-expand, .m-product-card__content, .m-product-card__info');
      var bg = card.getAttribute('data-joycraft-mobile-bg') || getComputedStyle(card).getPropertyValue('--joycraft-mobile-card-bg').trim();

      if (!isMobile) {
        card.style.removeProperty('background-color');
        nodes.forEach(function (node) {
          node.style.removeProperty('background-color');
        });
        return;
      }

      if (!bg) return;
      card.style.setProperty('background-color', bg, 'important');
      nodes.forEach(function (node) {
        node.style.setProperty('background-color', bg, 'important');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paintJoyCraftMobileCards);
  } else {
    paintJoyCraftMobileCards();
  }

  document.addEventListener('shopify:section:load', paintJoyCraftMobileCards);
  document.addEventListener('shopify:section:select', paintJoyCraftMobileCards);
  window.addEventListener('resize', paintJoyCraftMobileCards);
})();
